// SPDX-License-Identifier: MIT
// Copyright (c) 2022 The Pybricks Authors

import './index.scss';
import { compilerError } from './CompilerError';

// gathers all of the alert creation functions for passing up to the top level
export default {
    compilerError,
};
